module.exports = __webpack_public_path__ + "static/img/logo_white.568488e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/logo_white.svg
// module id = A4wR
// module chunks = 0